/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types'
import React, {Fragment} from 'react'
import {useIntl} from 'react-intl'

import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    Stack,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {styleConfigChakraKeys} from '../../../constants'

import RecentSearches from '@salesforce/retail-react-app/app/components/search/partials/recent-searches'
import {MinusIcon, PlusIcon} from '../../icons'
import {HideOnDesktop, HideOnMobile} from '../../responsive'
import Suggestions from './suggestions'
const SearchSuggestions = ({
    recentSearches,
    searchSuggestions,
    closeAndNavigate
}) => {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.search)
    const {formatMessage} = useIntl()

    const useSuggestions =
        searchSuggestions &&
        (searchSuggestions?.categorySuggestions?.length ||
            searchSuggestions?.contentSuggestions?.length ||
            searchSuggestions?.productSuggestions?.length)
    return (
        <Stack
            paddingTop="10px"
            paddingLeft="15px"
            paddingRight="15px"
            spacing={0}
        >
            {useSuggestions ? (
                <Fragment>
                    {searchSuggestions?.categorySuggestions?.length ? (
                        <>
                            <HideOnMobile>
                                <Text
                                    fontSize="24px"
                                    fontWeight="300"
                                    fontFamily={`'Raleway', sans-serif`}
                                    marginBottom="12px"
                                >
                                    Suggestion
                                </Text>
                                <Suggestions
                                    closeAndNavigate={closeAndNavigate}
                                    suggestions={
                                        searchSuggestions?.categorySuggestions
                                    }
                                />
                            </HideOnMobile>

                            <HideOnDesktop>
                                <Accordion allowMultiple marginBottom="20px">
                                    <AccordionItem borderTop="0">
                                        {({isExpanded}) => (
                                            <>
                                                <h2>
                                                    <AccordionButton p="0">
                                                        <Box
                                                            as="span"
                                                            flex="1"
                                                            textAlign="left"
                                                        >
                                                            <Text
                                                                {...styles.suggestionHead}
                                                            >
                                                                Suggestions
                                                            </Text>
                                                        </Box>
                                                        {isExpanded ? (
                                                            <MinusIcon marginBottom="15px" />
                                                        ) : (
                                                            <PlusIcon marginBottom="15px" />
                                                        )}
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel padding="0">
                                                    <Suggestions
                                                        closeAndNavigate={
                                                            closeAndNavigate
                                                        }
                                                        suggestions={
                                                            searchSuggestions?.categorySuggestions
                                                        }
                                                    />
                                                </AccordionPanel>
                                            </>
                                        )}
                                    </AccordionItem>
                                </Accordion>
                            </HideOnDesktop>
                        </>
                    ) : (
                        <></>
                    )}
                    {searchSuggestions?.brandSuggestions?.length ? (
                        <>
                            <HideOnMobile>
                                <Text
                                    fontSize="24px"
                                    fontWeight="300"
                                    fontFamily={`'Raleway', sans-serif`}
                                    marginBottom="12px"
                                >
                                    {formatMessage({
                                        id: 'search-suggestions.brands',
                                        defaultMessage: 'Brands'
                                    })}
                                </Text>
                                <Suggestions
                                    closeAndNavigate={closeAndNavigate}
                                    suggestions={
                                        searchSuggestions?.brandSuggestions
                                    }
                                />
                            </HideOnMobile>

                            <HideOnDesktop>
                                <Accordion allowMultiple marginBottom="20px">
                                    <AccordionItem borderTop="0">
                                        {({isExpanded}) => (
                                            <>
                                                <h2>
                                                    <AccordionButton p="0">
                                                        <Box
                                                            as="span"
                                                            flex="1"
                                                            textAlign="left"
                                                        >
                                                            <Text
                                                                {...styles.suggestionHead}
                                                            >
                                                                {formatMessage({
                                                                    id: 'search-suggestions.brands',
                                                                    defaultMessage:
                                                                        'Brands'
                                                                })}
                                                            </Text>
                                                        </Box>
                                                        {isExpanded ? (
                                                            <MinusIcon marginBottom="15px" />
                                                        ) : (
                                                            <PlusIcon marginBottom="15px" />
                                                        )}
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel padding="0">
                                                    <Suggestions
                                                        closeAndNavigate={
                                                            closeAndNavigate
                                                        }
                                                        suggestions={
                                                            searchSuggestions?.categorySuggestions
                                                        }
                                                    />
                                                </AccordionPanel>
                                            </>
                                        )}
                                    </AccordionItem>
                                </Accordion>
                            </HideOnDesktop>
                        </>
                    ) : (
                        <></>
                    )}

                    {/* {searchSuggestions?.contentSuggestions?.length ? (
                        <>
                            <Text fontWeight="1000">Content</Text>
                            <hr />
                            <Suggestions
                                closeAndNavigate={closeAndNavigate}
                                suggestions={
                                    searchSuggestions?.contentSuggestions
                                }
                            />
                        </>
                    ) : (
                        <></>
                    )} */}
                </Fragment>
            ) : (
                <RecentSearches
                    recentSearches={recentSearches}
                    closeAndNavigate={closeAndNavigate}
                />
            )}
        </Stack>
    )
}

SearchSuggestions.propTypes = {
    recentSearches: PropTypes.array,
    searchSuggestions: PropTypes.object,
    closeAndNavigate: PropTypes.func
}

export default SearchSuggestions
